exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".k7-count-box{\r\n    max-width: 4em;\r\n    \r\n}\r\n\r\n.k7-border-box{\r\n    width: 100%;\r\n}\r\n\r\n.k7-top-padding{\r\n    padding: 1em 0em 0em 1em;\r\n}\r\n\r\n#k7-offer-kendo-panel-bar{\r\n    margin: 0em 0em 1em 0em;\r\n}\r\n\r\n/**** img ****/\r\n\r\n.k7-position-img{\r\n    max-height: 9em;\r\n    \r\n}\r\n\r\n.k7-email-input{\r\n    display:table-cell;\r\n    width:100%;\r\n}\r\n\r\n.k7-job_preview {\r\n  max-height: 100px;\r\n  width: auto;\r\n  max-width: 100px;\r\n  margin: auto;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--7-1!./node_modules/postcss-loader/lib??postcss!./src/css/positioning/offer.css
// module id = ./node_modules/css-loader/index.js??ref--7-1!./node_modules/postcss-loader/lib/index.js??postcss!./src/css/positioning/offer.css
// module chunks = styles